import { axiosAction } from '../../utils/axiosAction';
import {
  FETCH_DELIVERY_HOURS,
  FETCH_SPECIAL_EVENT_REASONS,
  HOURS_CLEAR_ALL,
  HOURS_FETCH_ARRIVAL_HOURS,
  HOURS_FETCH_BASE_HOURS_OF_OPERATION,
  HOURS_FETCH_DAY_PART_HOURS,
  HOURS_SET_BASE_HOURS_OF_OPERATION,
  SET_BASE_OPERATION_HOUR_PERMISSION,
  HOURS_SET_EDITED,
  HOURS_SET_OPERATION_HOUR,
  HOURS_SET_OPERATION_HOUR_WEEKDAYS,
} from '../action-types/operation-hours-types';

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_OPERATION_HOURS}`;

export const setEdited = payload => {
  return {
    type: HOURS_SET_EDITED,
    payload,
  };
};
export const clearAll = () => ({
  type: HOURS_CLEAR_ALL,
});

export const setOperationHoursWeekDays = payload => {
  return {
    type: HOURS_SET_OPERATION_HOUR_WEEKDAYS,
    payload,
  };
};

export const setOperationHour = payload => ({
  type: HOURS_SET_OPERATION_HOUR,
  payload,
});

export const getDayPartTimes = restaurantId => async dispatch => {
  const endpoint = `${ENDPOINT}/${restaurantId}/day-part`;
  return axiosAction.get(endpoint, HOURS_FETCH_DAY_PART_HOURS, dispatch);
};
export const getArrivalTimes = restaurantId => async dispatch => {
  const endpoint = `${ENDPOINT}/${restaurantId}/arrival`;
  return axiosAction.get(endpoint, HOURS_FETCH_ARRIVAL_HOURS, dispatch);
};

export const getSpecialEventsReasons = () => async dispatch => {
  const endpoint = `${process.env.REACT_APP_ENDPOINT_SPECIAL_EVENT_REASONS}`;
  return axiosAction.get(endpoint, FETCH_SPECIAL_EVENT_REASONS, dispatch);
};

export const getDeliveryHours =
  (brand: string, countryId: number) => async dispatch => {
    const endpoint = `${process.env.REACT_APP_ENDPOINT_DELIVERY_HOURS}/${brand}?country=${countryId}`;
    return axiosAction.get(endpoint, FETCH_DELIVERY_HOURS, dispatch);
  };

export const getBaseOperationHours =
  (restaurantId, daysArray) => async dispatch => {
    const endpoint = `${ENDPOINT}/${restaurantId}?weekDay=${
      daysArray[daysArray.length - 1]
    }&setting=base`;
    return axiosAction.get(
      endpoint,
      HOURS_FETCH_BASE_HOURS_OF_OPERATION,
      dispatch,
    );
  };

export const setBaseOperationHours =
  (restaurantId, hoursObject) => async dispatch => {
    return axiosAction.patch(
      `${ENDPOINT}/${restaurantId}`,
      HOURS_SET_BASE_HOURS_OF_OPERATION,
      dispatch,
      hoursObject,
    );
  };

export const getBaseOperationHoursPermission = permissions => ({
  type: SET_BASE_OPERATION_HOUR_PERMISSION,
  payload: permissions,
});
